export const validateFileSize = (fileList: FileList): boolean => {
  if (!fileList?.length) return true;

  const maxFileSizeBytes = 10000000;
  const file = fileList.item(0) as File;
  const isSizeValid = file.size <= maxFileSizeBytes;

  return isSizeValid;
};
